//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

export enum MarketoIntegrationFeature {
  CreatorCampaignsSelfManagedLimit = 'CreatorCampaignsSelfManagedLimit',
  GalleriesInsightsBenchmarks = 'GalleriesInsightsBenchmarks',
  GalleriesInsightsContentCoverage = 'GalleriesInsightsContentCoverage',
  GalleriesInsightsOnsiteTraffic = 'GalleriesInsightsOnsiteTraffic',
  GalleriesMediaUploader = 'GalleriesMediaUploader',
  Like2BuyCustomizationsInstagram = 'Like2BuyCustomizationsInstagram',
  Like2BuyCustomizationsTikTok = 'Like2BuyCustomizationsTikTok',
  Like2BuyPinningInstagram = 'Like2BuyPinningInstagram',
  Like2BuyPinningTikTok = 'Like2BuyPinningTikTok',
  MentionsAndTagsRecommendedSorting = 'MentionsAndTagsRecommendedSorting',
  SchedulerDrafts = 'SchedulerDrafts',
  SchedulerGenAiCaption = 'SchedulerGenAiCaption',
  SchedulerPostTimeRecommendations = 'SchedulerPostTimeRecommendations',
  SocialAnalyticsFollowersOnlineInstagram = 'SocialAnalyticsFollowersOnlineInstagram',
  SocialAnalyticsFollowersOnlineTikTok = 'SocialAnalyticsFollowersOnlineTikTok',
  UIAVideoClosedCaptions = 'UIAVideoClosedCaptions',
  UIAVideoMute = 'UIAVideoMute',
}
